import { useQuery, UseQueryOptions } from "react-query";
import { AxiosError } from "axios";

import { fetchBrainstormIdeasStats } from "modules/collaboration/api/brainstorming";

import { BrainstormIdeasStatsResponse } from "modules/collaboration/types/res";

export const BRAINSTORM_IDEAS_STATS_QUERY_KEY = "/brainstorm_ideas/stats";

type BrainstormIdeasStatsQueryKey = [
  string,
  { params: { project_id: string } }
];

export const getBrainstormIdeasStatsQueryKey = (params: {
  project_id: string;
}): BrainstormIdeasStatsQueryKey => [
  BRAINSTORM_IDEAS_STATS_QUERY_KEY,
  { params }
];

export const useBrainstormIdeasStatsQuery = (
  params: { project_id: string },
  options: UseQueryOptions<
    BrainstormIdeasStatsResponse,
    AxiosError,
    BrainstormIdeasStatsResponse,
    BrainstormIdeasStatsQueryKey
  > = {}
) => {
  return useQuery<
    BrainstormIdeasStatsResponse,
    AxiosError,
    BrainstormIdeasStatsResponse,
    BrainstormIdeasStatsQueryKey
  >({
    queryKey: getBrainstormIdeasStatsQueryKey(params),
    queryFn: ({ queryKey: [, { params }] }) =>
      fetchBrainstormIdeasStats(params),
    keepPreviousData: false,
    ...options
  });
};
